import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-3">
            Product Categories
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Browse All Basetao Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our complete catalog of product categories with curated Basetao Spreadsheet resources for every shopping need.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 border border-secondary-200/70 hover:border-primary-300 rounded-lg overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-square overflow-hidden bg-secondary-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} category`}
                  title={`Basetao Spreadsheet ${cat.name}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="flex items-center gap-2.5 px-4 py-3">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-200 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}